import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, user } from '@angular/fire/auth';
import { doc, getDoc, Firestore } from '@angular/fire/firestore';
import { from, of, switchMap, take } from 'rxjs';

export const managerGuard: CanActivateFn = () => {
  const router = inject(Router);
  const firestore = inject(Firestore);

  return user(inject(Auth)).pipe(
    take(1),
    switchMap((u) => {
      if (!u) return of(router.createUrlTree(['/login']));
      return from(getDoc(doc(firestore, 'saasManagers', u.uid))).pipe(
        switchMap((snap) => of(snap.exists() ? true : router.createUrlTree(['/login']))),
      );
    }),
  );
};
